module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-dialog', {
    staticClass: "modal-login modal-action",
    attrs: {
      "visible": _vm.dialogVisible,
      "image-none": true
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      },
      "close": function($event) {
        _vm.$emit('close')
      }
    }
  }, [_c('div', {
    staticClass: "el-dialog__title",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('span', {
    staticClass: "img-check"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/icons/check.svg",
      "alt": ""
    }
  })]), _vm._v(" "), _c('span', [_vm._v("Tu producto se agregó al carrito con éxito")])]), _vm._v(" "), _c('div', {
    staticClass: "container-body"
  }, [_c('div', {
    staticClass: "image-container"
  }, [_c('img', {
    attrs: {
      "src": _vm.product.imgPresentation,
      "alt": "",
      "height": "90%",
      "width": "80%"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "content-body"
  }, [_c('p', {
    staticClass: "description"
  }, [_vm._v(_vm._s(_vm.product.description))]), _vm._v(" "), _c('p', {
    staticClass: "price-discount",
    style: (("color:" + (_vm.globalColors.primary)))
  }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.currency) + _vm._s(_vm.productPriceDiscount) + "\n\t\t\t\t")]), _vm._v(" "), _c('p', {
    staticClass: "price"
  }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.currency) + _vm._s(_vm.productPrice) + "\n\t\t\t\t")])])]), _vm._v(" "), _c('div', {
    staticClass: "container-buttons"
  }, [_c('button', {
    staticClass: "btn btn-orange",
    style: (("background-color:" + (_vm.globalColors.primary))),
    on: {
      "click": function($event) {
        _vm.$emit('go-to')
      }
    }
  }, [_vm._v("\n\t\t\t\tIR A CARRITO\n\t\t\t")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-underline",
    style: (("color:" + (_vm.globalColors.titulo))),
    on: {
      "click": function($event) {
        _vm.$emit('close')
      }
    }
  }, [_vm._v("\n\t\t\t\tSeguir comprando\n\t\t\t")])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ade75116","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modal-action.vue
// module id = 1155
// module chunks = 1